<template>
  <div class="content-page">
    <ChatPanel
      :isShowBoth="$screenSize.width > 767 ? true : false"
      @set-loading="(val) => (isLoading = val)"
    />
    <div v-if="isLoading" class="text-center pt-5">
      <div class="spinner-grow text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
import ChatPanel from "@/components/chat/ChatPanel";
export default {
  name: "chat-index",
  components: {
    ChatPanel,
  },
  data() {
    return {
      isLoading: true,
      profile: {
        chatId: "",
        name: "",
        email: "",
        photoUrl: "",
      },
    };
  },
  methods: {},
  mounted() {},
  created() {
    this.$isLoading = true;
  },
};
</script>

<style scoped>
.content-page {
  background-color: white;
  position: absolute;
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 50px - 104px);
}

@media (max-width: 767.98px) {
.content-page {
  background-color: white;
  position: fixed;
  top: 104px;
  width: 100%;
  height: 100%;
  z-index: 1010;
}

}
</style>
